<template>
  <div class="content">
    <ul class="tab">
      <li v-for="item in tab">
        <p :class="[item.flag ? 'cur' : '']" @click="toggle(item)">{{item.name}}</p>
      </li>
    </ul>
    <div class="sr-text">
      <template v-for="item in tab">
        <div class="sr-con" v-show="item.flag" v-html="DATA[item.text]"></div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      data: Object
    },
    data () {
      return {
        DATA: this.data,
        tab: [{
          flag: true,
          name: '产品介绍',
          text: 'productDescLong'
        }, {
          flag: false,
          name: '品牌故事',
          text: 'productStory'
        }]
      }
    },
    methods: {
      toggle (v) {
        this.tab.forEach(arr => {
          arr.flag = false
        })
        v.flag = true
      }
    }
  }
</script>

<style lang="less" scoped>
  .content {
    margin-top: 30px;
    .tab {
      text-align: center;
      list-style: none;
      li {
         display: inline-block;
         padding: 0 8px;
         p {
           width: 98px;
           height: 28px;
           line-height: 28px;
           background-color: #eee;
           cursor: pointer;
         }
         .cur {
            background-color: #cdad66;
           color: white;
         }
      }
    }
    .sr-text {
      padding: 30px;
      margin-bottom: 30px;
      background-color: white;
      border: 1px solid #eee;
      border-top-color: #cdad66;
      .sr-con {
        line-height: 2;
        overflow: hidden;
      }
      img {
        max-width: 100%;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/list-detail/sr-content.vue